export default __webpack_public_path__ + "static/media/kampus-merdeka.dafe007b.png";